import { c as _c } from "react/compiler-runtime";
import classNames from '@/utils/classNames';
export const contentLayoutClassName = ['[--gap-x:1.5rem]', '[--gap-y:1rem]', 'grid', 'w-full', 'min-h-full', 'overflow-auto', 'group-[.drawer]/modal:overflow-visible', 'group-[.drawer]/modal:w-[40rem]', 'group-[.drawer]/modal:grid-rows-[1rem_1rem_1rem_minmax(min-content,auto)_0rem_minmax(min-content,100%)_0rem]', 'grid-cols-[var(--gap-x)_auto_var(--gap-x)]', 'grid-rows-[var(--gap-y)_2rem_var(--gap-y)_minmax(min-content,auto)_var(--gap-y)_minmax(min-content,100%)_var(--gap-y)]', '[grid-template-areas:"._._."_"._content_."_"._content_."_"._content_."_"._content_."_"._content_."_"._._."]', '*:data-[slot=header]:[grid-area:header]', '*:data-[slot=content]:[grid-area:content]', '*:data-[slot=secondary-content]:[grid-area:secondary]', '*:data-[slot=secondary-content]:bg-stone-50', '*:data-[slot=secondary-content]:border-t', '*:data-[slot=secondary-content]:border-stone-200', 'has-[>[data-slot=header]]:[grid-template-areas:"._header_."_"._header_."_"._header_."_"._content_."_"._content_."_"._content_."_"._._."]', 'has-[>[data-slot=secondary-content]]:[grid-template-areas:"._._."_"._content_."_"._content_."_"._content_."_"._._."_"secondary_secondary_secondary"_"secondary_secondary_secondary"]', 'has-[>[data-slot=header]]:has-[>[data-slot=secondary-content]]:[grid-template-areas:"._header_."_"._header_."_"._header_."_"._content_."_"._._."_"secondary_secondary_secondary"_"secondary_secondary_secondary"]'].join(' ');
const Content = t0 => {
  const $ = _c(10);
  let children;
  let className;
  let props;
  if ($[0] !== t0) {
    ({
      children,
      className,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = className;
    $[3] = props;
  } else {
    children = $[1];
    className = $[2];
    props = $[3];
  }
  let t1;
  if ($[4] !== className) {
    t1 = classNames(contentLayoutClassName, className);
    $[4] = className;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] !== children || $[7] !== props || $[8] !== t1) {
    t2 = <div className={t1} {...props}>{children}</div>;
    $[6] = children;
    $[7] = props;
    $[8] = t1;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  return t2;
};
export default Content;